import { adjustContentVisibility, Section } from '@/components/shared/Content';
import { Flex, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import React from 'react';
import styled from 'styled-components';
import { SectionSubtitle, SectionTitlePet } from '../StyledElements';
import { PuppyKittenAnimation } from './PuppyKittenAnimation';

const StyledSection = styled(Section)`
  background: linear-gradient(0deg, ${themedColor('glass')} 13%, ${themedColor('white')} 13%);
  ${adjustContentVisibility};
`;
const SectionSubtitleExtension = styled(SectionSubtitle)`
  max-width: 1000px; // aboid text to break into 1 line in big screens
  ${MEDIA_QUERIES.mobile`
      padding: 0 1rem;
      br {
        display: none;
      }
  `}
`;

const PuppyKitten: React.FC = () => {
  return (
    <StyledSection pt={[50, 100]} pb={[0, 0]}>
      <SectionTitlePet>The best pet insurance for puppies and kittens</SectionTitlePet>
      <SectionSubtitleExtension>
        We created a preventative care package designed especially for the youngest members of your fur fam. It covers
        important procedures like spaying or neutering, microchipping, flea medication, and up to six vaccines or
        boosters
      </SectionSubtitleExtension>

      <Flex>
        <PuppyKittenAnimation />
      </Flex>
    </StyledSection>
  );
};

export default React.memo(PuppyKitten, () => true);
